import { ConfigObj } from './type';

export const LOCAL_CONFIG = (): ConfigObj => ({
  API_GATEWAY_URL: process.env.API_GATEWAY_URL || '',
  APP_URL: process.env.APP_URL || 'http://localhost:11000',
  AUTH_URL: process.env.AUTH_URL || 'http://localhost:11005',
  BUILD_ENV: process.env.BUILD_ENV || 'LOCAL',
  HYLIA_API_URL: process.env.HYLIA_API_URL || 'http://localhost:11030',
  HYLIA_ASSETS_URL: process.env.HYLIA_ASSETS_URL || 'http://localhost:11036',
  HYLIA_WEB_URL: process.env.HYLIA_WEB_URL || 'http://localhost:11050',
  MAMI_URL: process.env.MAMI_URL || 'http://localhost:11015',
  /* Shortcuts MAMI tracking calls on development only. Does not come from Vault, optional value for dev and above. */
  SHOULD_TRACK_MAMI_EVENTS: process.env.SHOULD_TRACK_MAMI_EVENTS || 'false',
  PAPI_URL: process.env.PAPI_URL || 'http://localhost:11010',
  PEAR002A_ASSETS_URL:
    process.env.PEAR002A_ASSETS_URL || 'http://localhost:11037',
  PEARMD_ASSETS_URL: process.env.PEARMD_ASSETS_URL || 'http://localhost:11035',
  SOMRYST_WEB_URL: process.env.SOMRYST_WEB_URL || 'http://localhost:11045',
  WEAVER_API_URL: process.env.WEAVER_API_URL || 'http://localhost:11055',
  /* DataDog variables */
  DD_APPLICATION_ID: process.env.DD_APPLICATION_ID || '',
  DD_CLIENT_TOKEN: process.env.DD_CLIENT_TOKEN || '',
  DD_ENV: process.env.DD_ENV || 'local',
  DD_TRACK_USER_INTERACTIONS: process.env.DD_TRACK_USER_INTERACTIONS || 'false',
  DD_TRACK_RESOURCES: process.env.DD_TRACK_RESOURCES || 'false',
  DD_TRACK_LONG_TASKS: process.env.DD_TRACK_LONG_TASKS || 'false',
});

export const WEAVER_API_CONFIG = (): ConfigObj => ({
  API_GATEWAY_URL: process.env.API_GATEWAY_URL || '',
  APP_URL: process.env.APP_URL || 'http://localhost:11000',
  AUTH_URL: process.env.AUTH_URL || 'http://localhost:11505',
  BUILD_ENV: process.env.BUILD_ENV || 'LOCAL',
  HYLIA_API_URL: process.env.HYLIA_API_URL || 'http://localhost:11534',
  HYLIA_ASSETS_URL: process.env.HYLIA_ASSETS_URL || 'http://localhost:11036',
  HYLIA_WEB_URL: process.env.HYLIA_WEB_URL || 'http://localhost:11050',
  MAMI_URL: process.env.MAMI_URL || 'http://localhost:11515',
  /* Shortcuts MAMI tracking calls on development only. Does not come from Vault, optional value for dev and above. */
  SHOULD_TRACK_MAMI_EVENTS: process.env.SHOULD_TRACK_MAMI_EVENTS || 'false',
  PAPI_URL: process.env.PAPI_URL || 'http://localhost:11510',
  PEAR002A_ASSETS_URL:
    process.env.PEAR002A_ASSETS_URL || 'http://localhost:11037',
  PEARMD_ASSETS_URL: process.env.PEARMD_ASSETS_URL || 'http://localhost:11035',
  SOMRYST_WEB_URL: process.env.SOMRYST_WEB_URL || 'http://localhost:11045',
  WEAVER_API_URL: process.env.WEAVER_API_URL || 'http://localhost:11500',
  /* DataDog variables */
  DD_APPLICATION_ID: process.env.DD_APPLICATION_ID || '',
  DD_CLIENT_TOKEN: process.env.DD_CLIENT_TOKEN || '',
  DD_ENV: process.env.DD_ENV || 'local',
  DD_TRACK_USER_INTERACTIONS: process.env.DD_TRACK_USER_INTERACTIONS || 'false',
  DD_TRACK_RESOURCES: process.env.DD_TRACK_RESOURCES || 'false',
  DD_TRACK_LONG_TASKS: process.env.DD_TRACK_LONG_TASKS || 'false',
});

export const DEMO_CONFIG = (): ConfigObj => ({
  API_GATEWAY_URL: process.env.API_GATEWAY_URL || 'https://demo-api.prepear.it',
  APP_URL: process.env.APP_URL || 'https://demo.pear.md',
  AUTH_URL: process.env.AUTH_URL || '',
  BUILD_ENV: process.env.BUILD_ENV || 'DEMO',
  HYLIA_API_URL:
    process.env.HYLIA_API_URL || 'https://demo-hylia-api.peartx.com/',
  HYLIA_ASSETS_URL:
    process.env.HYLIA_ASSETS_URL || 'https://demo-assets.peartx.com/hylia',
  HYLIA_WEB_URL: process.env.HYLIA_WEB_URL || 'http://localhost:11600',
  MAMI_URL: process.env.MAMI_URL || 'https://demo-events.peartx.com',
  SHOULD_TRACK_MAMI_EVENTS: process.env.SHOULD_TRACK_MAMI_EVENTS || 'true',
  PAPI_URL: process.env.PAPI_URL || 'https://demo-api.peartx.com',
  PEAR002A_ASSETS_URL:
    process.env.PEAR002A_ASSETS_URL ||
    'https://demo-assets.peartx.com/pear-002a',
  PEARMD_ASSETS_URL:
    process.env.PEARMD_ASSETS_URL || 'https://demo-assets.peartx.com/pear.md',
  SOMRYST_WEB_URL:
    process.env.SOMRYST_WEB_URL || 'https://demo-somryst-web.peartx.com',
  WEAVER_API_URL:
    process.env.WEAVER_API_URL || 'https://weaver-api.dev.prepear.it',
  /* DataDog variables */
  DD_APPLICATION_ID: process.env.DD_APPLICATION_ID || '',
  DD_CLIENT_TOKEN: process.env.DD_CLIENT_TOKEN || '',
  DD_ENV: process.env.DD_ENV || 'dev',
  DD_TRACK_USER_INTERACTIONS: process.env.DD_TRACK_USER_INTERACTIONS || 'false',
  DD_TRACK_RESOURCES: process.env.DD_TRACK_RESOURCES || 'false',
  DD_TRACK_LONG_TASKS: process.env.DD_TRACK_LONG_TASKS || 'false',
});

export const STAGING_CONFIG = (): ConfigObj => ({
  API_GATEWAY_URL:
    process.env.API_GATEWAY_URL || 'https://staging-api.prepear.it',
  APP_URL: process.env.APP_URL || 'https://staging.pear.md',
  AUTH_URL: process.env.AUTH_URL || '',
  BUILD_ENV: process.env.BUILD_ENV || 'staging',
  HYLIA_API_URL:
    process.env.HYLIA_API_URL || 'https://staging-hylia-api.peartx.com',
  HYLIA_ASSETS_URL:
    process.env.HYLIA_ASSETS_URL || 'https://staging-assets.peartx.com/hylia',
  HYLIA_WEB_URL:
    process.env.HYLIA_WEB_URL || 'https://hylia-web.staging.prepear.it',
  MAMI_URL: process.env.MAMI_URL || 'https://staging-events.peartx.com',
  SHOULD_TRACK_MAMI_EVENTS: process.env.SHOULD_TRACK_MAMI_EVENTS || 'true',
  PAPI_URL: process.env.PAPI_URL || 'https://staging-api.peartx.com',
  PEAR002A_ASSETS_URL: process.env.PEAR002A_ASSETS_URL || '',
  PEARMD_ASSETS_URL:
    process.env.PEARMD_ASSETS_URL ||
    'https://staging-assets.peartx.com/pear.md',
  SOMRYST_WEB_URL:
    process.env.SOMRYST_WEB_URL || 'https://staging-somryst-web.peartx.com',
  WEAVER_API_URL:
    process.env.WEAVER_API_URL || 'https://weaver-api.staging.prepear.it',
  /* DataDog variables */
  DD_APPLICATION_ID: process.env.DD_APPLICATION_ID || '',
  DD_CLIENT_TOKEN: process.env.DD_CLIENT_TOKEN || '',
  DD_ENV: process.env.DD_ENV || 'staging',
  DD_TRACK_USER_INTERACTIONS: process.env.DD_TRACK_USER_INTERACTIONS || 'false',
  DD_TRACK_RESOURCES: process.env.DD_TRACK_RESOURCES || 'false',
  DD_TRACK_LONG_TASKS: process.env.DD_TRACK_LONG_TASKS || 'false',
});

export const CI_CONFIG = (): ConfigObj => ({
  API_GATEWAY_URL: process.env.API_GATEWAY_URL || '',
  APP_URL: process.env.APP_URL || 'http://web_e2e',
  AUTH_URL: process.env.AUTH_URL || 'http://auth:9000',
  BUILD_ENV: process.env.BUILD_ENV || '',
  HYLIA_API_URL: process.env.HYLIA_API_URL || 'http://hylia_api:10800',
  HYLIA_ASSETS_URL: process.env.HYLIA_ASSETS_URL || 'http://hylia_assets',
  HYLIA_WEB_URL: process.env.HYLIA_WEB_URL || 'http://hylia_web',
  MAMI_URL: process.env.MAMI_URL || 'http://mami:3000',
  PAPI_URL: process.env.PAPI_URL || 'http://papi:3000',
  PEAR002A_ASSETS_URL:
    process.env.PEAR002A_ASSETS_URL || 'http://pear002a_assets',
  PEARMD_ASSETS_URL: process.env.PEARMD_ASSETS_URL || 'http://pearmd_assets',
  SOMRYST_WEB_URL: process.env.SOMRYST_WEB_URL || 'http://somryst_web',
  WEAVER_API_URL: process.env.WEAVER_API_URL || 'http://weaver_api:11500',
  /* DataDog variables */
  DD_APPLICATION_ID: process.env.DD_APPLICATION_ID || '',
  DD_CLIENT_TOKEN: process.env.DD_CLIENT_TOKEN || '',
  DD_ENV: process.env.DD_ENV || 'test',
  DD_TRACK_USER_INTERACTIONS: process.env.DD_TRACK_USER_INTERACTIONS || 'false',
  DD_TRACK_RESOURCES: process.env.DD_TRACK_RESOURCES || 'false',
  DD_TRACK_LONG_TASKS: process.env.DD_TRACK_LONG_TASKS || 'false',
});

export const TEST_CONFIG = (): ConfigObj => ({
  API_GATEWAY_URL: process.env.API_GATEWAY_URL || 'api-gateway',
  APP_URL: process.env.APP_URL || 'api-gateway',
  AUTH_URL: process.env.AUTH_URL || '',
  BUILD_ENV: process.env.BUILD_ENV || '',
  HYLIA_API_URL: process.env.HYLIA_API_URL || 'hylia-api',
  HYLIA_ASSETS_URL: process.env.HYLIA_ASSETS_URL || 'hylia-assets',
  HYLIA_WEB_URL: process.env.HYLIA_WEB_URL || 'hylia-web',
  MAMI_URL: process.env.MAMI_URL || 'mami',
  PAPI_URL: process.env.PAPI_URL || 'papi',
  PEAR002A_ASSETS_URL: process.env.PEAR002A_ASSETS_URL || 'pear-002a-assets',
  PEARMD_ASSETS_URL: process.env.PEARMD_ASSETS_URL || 'pear-md-assets',
  SOMRYST_WEB_URL: process.env.SOMRYST_WEB_URL || 'somryst',
  WEAVER_API_URL: process.env.WEAVER_API_URL || 'weaver-api',
  /* DataDog variables */
  DD_APPLICATION_ID: process.env.DD_APPLICATION_ID || '',
  DD_CLIENT_TOKEN: process.env.DD_CLIENT_TOKEN || '',
  DD_ENV: process.env.DD_ENV || 'test',
  DD_TRACK_USER_INTERACTIONS: process.env.DD_TRACK_USER_INTERACTIONS || 'false',
  DD_TRACK_RESOURCES: process.env.DD_TRACK_RESOURCES || 'false',
  DD_TRACK_LONG_TASKS: process.env.DD_TRACK_LONG_TASKS || 'false',
});

export const getEnvConfig = (useEnv?: string): ConfigObj | null => {
  const { CONFIG_ENV, NODE_ENV } = process.env;
  switch (useEnv || CONFIG_ENV || NODE_ENV) {
    case 'weaver-api':
      return WEAVER_API_CONFIG();
    case 'local':
      return LOCAL_CONFIG();
    case 'demo':
      return DEMO_CONFIG();
    case 'ci':
      return CI_CONFIG();
    case 'test':
      return TEST_CONFIG();
    case 'staging':
      return STAGING_CONFIG();
  }
  return null;
};
